import { createFileRoute } from '@tanstack/react-router';
import Audits from 'src/components/0500_audits/dystopia_rising';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/transactions_audit',
)({
  component: Audits,
});
